import React from "react";
import { AnimatePresence, motion } from "framer-motion";

const Modal = ({ isOpen, title, children, onClose, maxWidth = "max-w-2xl" }) => {
  return (
    <AnimatePresence>
      {isOpen ? (
        <motion.div
          className="fixed inset-0 z-[70] bg-black/50 px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <div className="min-h-full flex items-center justify-center py-8">
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 20, opacity: 0 }}
              transition={{ duration: 0.25 }}
              onClick={(e) => e.stopPropagation()}
              className={`w-full ${maxWidth} rounded-2xl bg-white shadow-2xl`}
            >
              <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
                <h3 className="text-xl font-semibold text-maroon">{title}</h3>
                <button
                  type="button"
                  onClick={onClose}
                  className="rounded-full border border-gray-200 px-3 py-1 text-sm text-maroon hover:bg-gray-100"
                >
                  Close
                </button>
              </div>
              <div className="p-6">{children}</div>
            </motion.div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default Modal;
